define('views/shop/instore/ecard_purchase',[
	"backbone",
	"views/_base/baseview",
	"text!views/shop/instore/ecard_purchase.html",
	"views/shared/button/button",
	"models/linkedcards/linkedcard_collection",
	"models/ecard/ecard_purchase",
	"models/ecard/ecard_status",
	"views/shared/modal/modal_modern",
	"views/shop/instore/terms",
	"views/ecards/passkit",
], function (
	Backbone,
	BaseView,
	Template,
	ButtonComponent,
	LinkedCardsModel,
	EcardPurchaseModel,
	EcardStatusModel,
	Modal,
	TermsView,
	PassKitView
) {
	"use strict";

	return BaseView.extend({
		className: "ecard-purchase-container",
		tagName: "div",
		isRender: true,
		needsAuth: false,
		template: _.template(Template),
		events: {
			"change .js-ecard-purchase-source": "handlePaymentSourceChange",
			"focus .js-ecard-purchase-amount": "handleFocusPurchaseAmount",
			"keyup .js-ecard-purchase-amount": "handleKeyupPurchaseAmount",
			"blur .js-ecard-purchase-amount": "handleBlurPurchaseAmount",
			"click .js-ecard-purchase-terms": "showEcardTerms",
		},
		initialize: function (options) {
			var options = options || {};

			this.print = options.print;
			this.merchant = options.merchant;
			this.ecard_data = options.ecard_data;
			this.ecard_total = options.ecard_total;
			this.parent_view = options.parent_view;

			// console.log('options', options);
			// console.log("this context", this);

			// Payment Defaults
			this.purchase_button = null;
			this.purchase_amount = 0;
			this.payment_source = null;
			this.reference_number = null;
			this.ecard_purchase_status = null;
			this.ecard_purchase_status_count = 0;
			this.ecard_purchase_status_interval = 5000;

			this.elementName = options.elementName;

			BaseView.prototype.initialize(this);
		},

		render: function () {
			var that = this;

			checkFinRegStatus(function () {
				that.$el.html(that.template());

				that.addPaymentRestrictions();
			});

			return this;
		},

		loadData: function () {
			var that = this;

			$(".js-ecard-purchase-source").html("");

			that.getLinkedCards();
			that.addPaymentButton();
		},

		addPaymentRestrictions: function () {
			var min = "$" + this.ecard_data.MinAmount,
				max = "$" + this.ecard_data.MaxAmount;

			this.$(".js-ecard-purchase-amount-min").html(min);
			this.$(".js-ecard-purchase-amount-max").html(max);
		},

		getLinkedCards: function () {
			var that = this;

			this.linked_cards = new LinkedCardsModel({ instanceURL: pf.consumerURL + "/LinkedCards?smc=true&sa=true" });

			this.linked_cards.fetch({
				success: function (model, resp) {
					if (that.linked_cards.length) {
						that.listCards();
					}
				},
				error: function () {
					// TODO: Empy error state
				},
			});
		},

		listCards: function () {
			var that = this,
				found_default = false,
				spending_account = null,
				cards = this.linked_cards.toJSON();

			$(".js-ecard-purchase-source").html("");

			cards.forEach(function (card) {
				if (card.IsDefault) {
					found_default = true;
					that.payment_source = card;
				}

				if (card.CardTypeID == enums.cardTypes.GPRDebitCard) {
					spending_account = card;
				}

				that.addCard(card);
			});

			$(".js-ecard-purchase-source").attr("disabled", false);

			// If we did not find a default account, assign the spending account to be default
			if (!found_default) {
				this.payment_source = spending_account;
			}
		},

		addCard: function (card) {
			var guid = card.LinkedCardGUID,
				name = card.NickName,
				expiration_date = card.IsExpired ? "- Exp " + card.ExpirationMonth + "/" + card.ExpirationYear : "",
				is_default = card.IsDefault ? "selected" : "",
				expiration_status = card.IsExpired ? "disabled" : "";

			if (card.CardTypeID === enums.cardTypes.GPRDebitCard) {
				name = "PayForward Account (" + formatBalanceCurrency(card.AvailableBalance) + ")";
			} else if (card.NetworkSourceID === enums.networkSources.Visa) {
				name = "Visa - " + name;
			} else if (card.NetworkSourceID === enums.networkSources.MasterCard) {
				name = "MasterCard - " + name;
			}

			//format nickname if it's too long & is not the default PF account
			if (name.length > 23 && !name.startsWith("PayForward Account")) {
				name = name.slice(0, 23) + "...";
			}

			var optionHTML =
				'<option value="' +
				guid +
				is_default +
				'"' +
				expiration_status +
				">" +
				name +
				" " +
				expiration_date +
				"</option>";

			$(".js-ecard-purchase-source").append(optionHTML);
		},

		addPaymentButton: function () {
			this.purchase_button = new ButtonComponent({
				// General
				elementName: ".js-ecard-purchase-button",
				calling_view: this,
				// Transactional
				is_transaction: true,
				transaction_callback: this.invalidTransaction,
				// Default
				btn_label: "Purchase",
				btn_callback: this.validatePurchase,
				btn_retry_callback: this.validatePurchase,
				// Confirm
				btn_confirm: true,
				btn_confirm_amount: 0,
				btn_confirm_label: "Confirm",
				btn_confirm_callback: this.processPurchase,
				// Cancel
				btn_cancel: this.ecard_total > 0 ? true : false,
				btn_cancel_label: "Use Existing eGift Card",
				btn_cancel_callback: this.showExistingEcards,
				// Success
				btn_success: true,
				btn_success_delay: 700,
				btn_success_label: "View eGift Card",
				btn_success_message: "eGift Card successfully purchased",
				btn_success_callback: this.viewEcard,
				// Error
				btn_error: true,
				btn_error_delay: 700,
				btn_error_label: "Retry",
				btn_error_cancel_label: "Cancel",
				btn_error_message: "Could not complete purchase",
				btn_error_callback: this.canceledOnError,
			});
		},

		invalidTransaction: function (response) {
			this.showPurchaseAmountError();
		},

		validatePurchase: function (proceedToConfirm, that) {
			var that = that ? that : this;

			checkFinRegStatus(function (resp) {
				if (
					that.purchase_amount >= that.ecard_data.MinAmount &&
					that.purchase_amount <= that.ecard_data.MaxAmount
				) {
					if (
						that.payment_source.CardTypeID == enums.cardTypes.GPRDebitCard &&
						that.payment_source.AvailableBalance < that.purchase_amount
					) {
						that.showPurchaseAmountError();
						return false;
					}

					that.$(".js-ecard-purchase-amount").parent().removeClass("error");
					that.$(".js-form-feedback").html("");

					if (proceedToConfirm.name) {
						that.purchase_button[proceedToConfirm.name]();
					} else {
						proceedToConfirm(that.purchase_button);
					}
				} else {
					that.showPurchaseAmountError();
				}
			});
		},

		showPurchaseAmountError: function () {
			this.$(".js-ecard-purchase-amount").parent().addClass("error");

			if (this.purchase_amount < this.ecard_data.MinAmount || this.purchase_amount > this.ecard_data.MaxAmount) {
				this.$(".js-form-fine-print").addClass("error");
			} else {
				this.$(".js-form-fine-print").removeClass("error");
			}

			if (
				this.payment_source &&
				this.payment_source.CardTypeID == enums.cardTypes.GPRDebitCard &&
				this.payment_source.AvailableBalance < this.purchase_amount
			) {
				var text = "Insufficient funds";

				this.$(".js-form-feedback").html(text);
			} else {
				this.$(".js-form-feedback").html("");
			}
		},

		processPurchase: function (processComplete, that) {
			var that = that ? that : this,
				reference_number = createReferenceNumber(),
				request = {
					REFNO: reference_number,
					UGUID: pf.session.get("UserGUID"),
					PM: 1,
					CID: null,
					MGUID: that.ecard_data.DefaultMerchantGUID,
					AMT: that.purchase_amount,
					AGID: 2,
				};

			if (that.payment_source.CardTypeID == enums.cardTypes.GPRDebitCard) {
				request.PM = 1;
				request.PCGUID = that.payment_source.ExtProxyNumber;
				request.CID = that.payment_source.ClientID;
			} else {
				request.PM = 2;
				request.PCGUID = that.payment_source.LinkedCardGUID;
				request.CID = that.payment_source.ClientID;
			}

			that.ecard_purchase_model = new EcardPurchaseModel(request);

			that.ecard_purchase_model.save(null, {
				success: function (model, resp) {
					// Save ref number (refNumber) until interval sends 200 code
					that.reference_number = reference_number;
					// Start polling
					that.startStatusInterval(model, resp, processComplete, that);
				},
				error: function (resp) {
					// If message comes from server, overwrite the generic response
					if (resp.hasOwnProperty("bhmsg")) {
						var error = JSON.parse(resp.bhmsg),
							text = error.ErrorMessage;

						that.purchase_button.updateErrorMessage(text);
					} else {
						var text = "Could not complete purchase";

						that.purchase_button.updateErrorMessage(text);
					}

					if (processComplete.name) {
						that.purchase_button[processComplete.name](false);
					} else {
						processComplete(false, that.purchase_button);
					}
				},
			});
		},

		startStatusInterval: function (model, resp, processComplete, that) {
			that.ecard_purchase_status = setInterval(function () {
				// Call the polling endpoint
				that.callStatusEndpoint(model, resp, processComplete, that);
			}, that.ecard_purchase_status_interval);
		},

		callStatusEndpoint: function (model, resp, processComplete, that) {
			that.ecard_purchase_state = new EcardStatusModel({
				REFNO: that.reference_number,
			});

			that.ecard_purchase_status_count = that.ecard_purchase_status_count + 1;

			if (that.ecard_purchase_status_count == 12) {
				clearInterval(that.ecard_purchase_status);

				var text = pf.getContent("ecard.error.lost_transaction").replace("{merchant}", that.MerchantGroupName);

				that.purchase_button.updateErrorMessage(text);

				if (processComplete.name) {
					that.purchase_button[processComplete.name](false);
				} else {
					processComplete(false, that.purchase_button);
				}
			}

			that.ecard_purchase_state.fetch({
				success: function (modelStatus, response, options) {
					// EXAMPLE response: {"success":true,"gcguid":"4788c924f385475d953f69abec8aab67","gcid":1222,"REFNO":"eXSdmJ9VN7BfGSAD6XXMItuaFJ5sOCOe"}

					// 202: Processing, 200: Good
					if (options.xhr.status == 200) {
						clearInterval(that.ecard_purchase_status);

						if (response.hasOwnProperty("success") && response.success == true) {
							that.ecard_details = response;

							if (processComplete.name) {
								that.purchase_button[processComplete.name](true);
							} else {
								processComplete(true, that.purchase_button);
							}
						} else {
							// If message comes from server, overwrite the generic response
							if (response.hasOwnProperty("errorcode") && response.errorcode == 6) {
								var text =
									"We are unable to process your request. Please contact your issuing bank or select a different payment card.";

								that.purchase_button.updateErrorMessage(text);
							} else if (response.hasOwnProperty("bhmsg")) {
								var error = JSON.parse(response.bhmsg),
									text = error.ErrorMessage;

								that.purchase_button.updateErrorMessage(text);
							} else {
								var text = "Could not complete purchase";

								that.purchase_button.updateErrorMessage(text);
							}

							if (processComplete.name) {
								that.purchase_button[processComplete.name](false);
							} else {
								processComplete(false, that.purchase_button);
							}
						}
					}
				},
				error: function (response) {
					// Clear Interval
					clearInterval(that.ecard_purchase_status);

					// If message comes from server, overwrite the generic response
					if (response.hasOwnProperty("bhmsg")) {
						var error = JSON.parse(response.bhmsg),
							text = error.ErrorMessage;

						that.purchase_button.updateErrorMessage(text);
					} else {
						var text = "Could not complete purchase";

						that.purchase_button.updateErrorMessage(text);
					}

					if (processComplete.name) {
						that.purchase_button[processComplete.name](false);
					} else {
						processComplete(false, that.purchase_button);
					}
				},
			});
		},

		viewEcard: function (resetButtons, that) {
			var that = that ? that : this;

			if (that.parent_view.wallet) {
				that.parent_view.loadEcards(function (ecards) {
					var merchant_id = that.parent_view.data.key,
						merchant_ecards = [];

					ecards.forEach(function (ecard) {
						if (ecard.MerchantGroupGUID == merchant_id) {
							merchant_ecards.push(ecard);
						}
					}, that);

					that.parent_view.data.ecards = merchant_ecards;
					that.parent_view.gcguid = that.ecard_details.gcguid;
					that.showPasskit();

					// Update the wallet group eCard count
					that.parent_view.calling_view_MODAL.$el.find(".ecard-count").html(merchant_ecards.length);
				});
			} else {
				that.parent_view.loadEcards(function () {
					that.showPasskit();
				});
			}
		},

		showPasskit: function (gcguid) {
			// If on wallet close previous modal and then show passkit modal
			if (this.parent_view.wallet) {
				this.closeMODAL();

				var data = {
					data: this.parent_view.data,
					// gcguid            : this.ecard_details.gcguid,
					gcguid: this.parent_view.gcguid,
					header: this.parent_view.header,
					wallet: this.parent_view.wallet,
					merchant: this.parent_view.merchant,
					self_contained: this.parent_view.self_contained,
					calling_view_MODAL: this.parent_view.calling_view_MODAL,
				};
			} else {
				var ecards = this.parent_view.ecards.models;

				var data = {
					gcguid: this.ecard_details.gcguid,
					merchant: this.merchant,
					data: {
						name: this.merchant.MerchantGroupName,
						ecards: ecards,
					},
				};
			}

			this.passkit = new PassKitView(data);

			var passkit_modal = new Modal({
				show: true,
				content: this.passkit.$el.html(),
				calling_view: this.passkit,
			});
		},

		showExistingEcards: function (that) {
			var that = that ? that : this;
			// console.log('ecard_purchase showExistingEcards',this.parent_view)

			that.parent_view.showEcardsMODAL();

			// if(_.isFunction(this.parent_view.calling_view_MODAL.showEcardsMODAL)){
			//     this.parent_view.calling_view_MODAL.showEcardsMODAL();
			// } else if(_.isFunction(this.parent_view.showEcardsMODAL)){
			//     this.parent_view.showEcardsMODAL();
			// }
		},

		canceledOnError: function (that) {
			// console.log('ecard_purchase: canceledOnError');
		},

		handleKeyupPurchaseAmount: function (e) {
			var data = keyupCurrencyHandling(e);

			$(e.target).val(data.string);

			this.purchase_button.updateCofirmAmount(Number(data.number));
		},

		handleBlurPurchaseAmount: function (e) {
			var data = blurCurrencyHandling(e);

			$(e.target).val(data.string);

			this.purchase_amount = Number(data.number);

			this.purchase_button.updateCofirmAmount(this.purchase_amount);
		},

		handleFocusPurchaseAmount: function () {
			if (this.purchase_amount > 0) {
				this.purchase_button.resetButtonState();
			}
		},

		handlePaymentSourceChange: function (e) {
			var that = this,
				card_id = $(e.target).val(),
				cards = this.linked_cards.toJSON();

			cards.forEach(function (card) {
				if (card.LinkedCardGUID == card_id) {
					that.payment_source = card;
				}
			});
		},

		showEcardTerms: function (e) {
			if (e && e.preventDefault) {
				e.preventDefault();
			}
			if (e && e.stopPropagation) {
				e.stopPropagation();
			}

			var terms = new TermsView({ terms: this.ecard_data.TermsAndCondition });

			var ecard_modal = new Modal({
				show: true,
				content: terms.$el.html(),
				className: "wide",
				calling_view: this,
			});
		},

		closeMODAL: function () {
			$("#pf-modal-modern").fadeOut(function () {
				$("#pf-modal-modern").remove();
			});
		},

		close: function () {},
	});
});

